import { render, staticRenderFns } from "./SidebarAboutBuffer.vue?vue&type=template&id=52555576&"
import script from "./SidebarAboutBuffer.vue?vue&type=script&lang=js&"
export * from "./SidebarAboutBuffer.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAboutBuffer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports